var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveSnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "5 5 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2052 17.5416C35.2006 17.5416 35.1983 17.5839 35.4922 15.792C35.5604 15.377 35.2843 14.9844 34.8757 14.9152C34.4675 14.8459 34.0807 15.1265 34.0125 15.5415C33.7114 17.3767 33.7239 17.3287 33.7192 17.3287C33.4266 17.3516 33.1435 17.4197 32.8772 17.5273V13.7619C32.8772 13.3411 32.5414 13 32.1271 13C31.7129 13 31.3771 13.3411 31.3771 13.7619C31.3771 19.5855 31.3911 18.5146 31.3911 18.8621C31.1405 19.3288 30.8567 20.4274 29.8863 22.5246C29.4141 20.5788 28.4496 18.8582 26.7796 17.823C24.6823 16.5234 21.584 16.5843 19.4087 17.4059C13.3293 19.7005 12.6385 28.1923 18.5283 30.876L13.5206 32.5127C13.169 32.6275 12.9519 32.9856 13.0091 33.3561C13.0668 33.7266 13.3809 34 13.7503 34H28.6412C30.3387 34 31.8496 32.8419 32.3161 31.1842L34.4861 23.4695L35.5939 22.7943C37.6246 21.5569 37.4218 18.4711 35.2052 17.5416ZM21.7058 22.619C20.6172 22.619 20.0012 23.1228 19.6763 23.5457C19.2254 24.1324 19.0397 24.9424 19.2038 25.6091C19.4022 26.4151 20.5523 27.6066 21.5787 26.8249C22.3325 26.2511 22.2267 25.6798 21.7916 25.5324C21.3987 25.3996 21.1863 24.9677 21.3171 24.5686C21.4484 24.1695 21.8731 23.9538 22.266 24.0867C23.7884 24.6025 24.2761 26.6742 22.4788 28.044C20.5652 29.5022 18.2176 27.8849 17.7487 25.9787C17.2026 23.76 18.7671 21.0951 21.7058 21.0951C25.5328 21.0951 27.5777 24.9114 26.2573 27.9821C25.5387 28.6197 24.8275 28.9883 24.1454 29.0574C24.0393 29.0679 24.0921 29.0569 23.0484 29.3983C24.204 28.7295 25.1547 27.4597 25.1547 26.122C25.1547 24.3814 23.9701 22.619 21.7058 22.619Z",
    fill: "#003E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 36L13 13",
    stroke: "#ED3431",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 16,
    stroke: "#ED3431",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveSnail);
export default __webpack_public_path__ + "static/media/Remove-Snail.057574408f6fac8b29206b5bef2b43db.svg";
export { ForwardRef as ReactComponent };